module.exports = "<div layout=column layout-fill> <md-toolbar> <app-header></app-header> </md-toolbar> <md-content flex style=background-color:transparent class=main-content> <ui-view autoscroll> <div layout=row layout-align=\"center center\"> <img src=" + require("/Users/yo/Documents/MAC_TOQIO/Documents/projects/thesafezone/thesafezone-fe/src/assets/icons/loading.svg") + " alt=\"Loading app...\"> </div> </ui-view> </md-content> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/containers/app/app.html
// module id = 153
// module chunks = 1